module.exports = __webpack_public_path__ + "media/images/slide-1-a3124051b24f9b53c29cfca7374e1d41.jpg";